import React from "react";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

const UnderlinedLabel = (props) => {
    return (
        <div>
            <Typography variant={'subtitle1'} gutterBottom>
                {props.title}
            </Typography>
            <Divider/>
        </div>
    )
};

export default UnderlinedLabel;